import { z } from 'zod';

const recipeSchema = z.object({
  id: z.number(),
  title: z.string(),
  portions: z.string(),
  chickenPiece: z.string(),
  icon: z.string(),
  time: z.string(),
  calories: z.string(),
  description: z.string(),
  ingredients: z.array(z.string()),
  preparation: z.array(z.string()),
  country: z.string(),
  originalLink: z.string(),
});

const dataSchema = z.array(recipeSchema);

export default dataSchema;
